import React, { Fragment } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { Col, Container } from 'reactstrap'
import { H3,P ,Btn } from '../../../AbstractElements'
import { BACK_TO_HOME_PAGE, ErrorPageContent, Pagenotfound } from '../../../Constant'
import { Error5 } from '../../../Data/Page/Svg'

const Error_page6 = () => {
  return (
    <Fragment>
       <div className='page-wrapper compact-wrapper' id='pageWrapper'>
          <div className='error-wrapper mt-4'>
            <Container>
              <div className='svg-wrapper error5'>
                <Error5/>
              </div>
              <Col md="8" className="offset-md-2">
                  <H3>{Pagenotfound}</H3>
                  <p className='text-secondary'>Sorry, we couldn't find the page you were looking for.</p>
                  <NavLink className={'btn btn-primary'} to={'/'}>Go back home</NavLink>
              </Col>
            </Container>
          </div>
      </div>  
    </Fragment>
  )
}

export default Error_page6